// import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BrandProfileService} from './brand-profile.service';
import { SharedService} from './shared.service';
import { SharedSignalService} from './shared-signal.service';

// @Injectable({
//   providedIn: 'root'
// })
// export class BrandProfileFactoryService {

//   constructor() { }
// }

export function brandProfileFactory(
  brandProfileService: BrandProfileService,
  sharedService: SharedService,
  sharedSignalService: SharedSignalService
) {
  return () => {
    // console.log('brandProfileFactory - started');
    const url = new URL(location.href);
    console.log(url);
    const params = url.searchParams;
    let sessionId: string = params.get('sid') || '';
    let envRegion: string = params.get('er') || '';
    // console.log('sessionId', sessionId);
    // console.log('envRegion', envRegion);
    
    if (!sessionId || !envRegion) {
      return;
    }

    sharedService.setDsbSessionGuid(sessionId);
    sharedService.setEnvRegion(envRegion);
    sharedSignalService.setDsbSessionGuid(sessionId);
    sharedSignalService.setEnvRegion(envRegion);

    brandProfileService
      .getBrandProfile(envRegion, sessionId)
      .toPromise()
      .then((response) => {
        console.log('result', response);
        if (response) {
          sharedService.setBrandProfile(response);
          sharedSignalService.setBrandProfile(response);
          console.log('brandProfileFactory - completed');
        }
      });

    };
}
